import { render } from "./CuratedArtworksBlock.vue?vue&type=template&id=1e396e6a&scoped=true"
import script from "./CuratedArtworksBlock.vue?vue&type=script&lang=js"
export * from "./CuratedArtworksBlock.vue?vue&type=script&lang=js"

import "./CuratedArtworksBlock.vue?vue&type=style&index=0&id=1e396e6a&lang=scss&scoped=true"

import exportComponent from "/opt/project/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e396e6a"]])

export default __exports__